import axios from 'axios'
import serverConfig from '../api/graphql.js';
var validate = require('jsonschema').validate;
const instance = serverConfig.getInstance();

const registerCommandSchema = {
    "type": "object",
    "properties": {
        "email": {
            "type": "string",
            "pattern" : "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$"
        },
        "firstName": {
            "type": "string",
            "minLength": 2
        },
        "lastName": {
            "type": "string",
            "minLength": 2
        }
    },
    "required": [
        "email",
        "firstName",
        "lastName"
    ]
}

export default {
  checkRegisterCommand: function(visitor){
    return validate(visitor, registerCommandSchema);
  },
  register: (visitor) => {
            var query = `mutation RegisterVisitor($input: RegisterVisitorCommand = {username: "${visitor.email}",screenName: "${visitor.firstName} ${visitor.lastName}"}) {
              		User {
              			register(input: $input){
              				correlationId
              			}
              		}
              	}`;
            console.log(query);
            return instance.post('',JSON.stringify({
                  "query": query
              }),serverConfig.properties);
          }
}
